import { z } from 'zod';

export const ParsedNumber = z.preprocess((x) => {
    if (x instanceof Object) {
        if ((x as any)._bsontype === 'Decimal128') {
            return parseFloat((x as any).toString());
        }

        if ((x as any).$numberDecimal) {
            return parseFloat((x as any).$numberDecimal);
        }
    }

    return x;
}, z.number());
